export enum GAParamsEnum {
  GLOBAL_ACCOUNT_INTEREST = 'GLOBAL_ACCOUNT_INTEREST',
  GLOBAL_ACCOUNT_COMPLETE = 'GLOBAL_ACCOUNT_COMPLETE',
  GLOBAL_ACCOUNT_HIDDEN = 'GLOBAL_ACCOUNT_HIDDEN',
}
